import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54f1b4fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between p-4 border-bottom-grey-2" }
const _hoisted_2 = { class: "flex items-center gap-4 flex-wrap w-full" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-sm" }, "Filter:")
], -1))
const _hoisted_4 = { class: "ml-auto" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-sync" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Reset Filter ")

import { onMounted, ref, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'
import apiUseCase from '@/usecase/apiUseCase'
import { ITrayek } from '@/utils/interfaces/iTrayek'
import { MSClass } from '@/utils/interfaces/iMsClass'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'


export default /*#__PURE__*/_defineComponent({
  __name: 'InlineFilter',
  setup(__props) {

const store = useStore()
const module = 'plotting'
const endpointTrayek = '/management/v1/Trayek'
const endpointClass = '/management/v1/MsClass'

const classList = ref<MSClass[]>([])
const trayekList = ref<ITrayek[]>([])
const optionTol = ref([
  { label: 'Tol', value: 'true' },
  { label: 'Non Tol', value: 'false' }
])

const selectedTrayek = ref(null)
const selectedClass = ref(null)
const selectedTol = ref(null)

const getAllClass = async () => {
  const { result, error } = await apiUseCase.get(`${endpointClass}${returnUrlPrams({
    custom: [['activeOnly', '=', 'true']],
    pageSize: 100
  })}`)
  if (!error) {
    classList.value = result as MSClass[]
  }
}

const getAllTrayek = async () => {
  const { result, error } = await apiUseCase.get(`${endpointTrayek}${returnUrlPrams({
    pageSize: 200,
    custom: [['activeOnly', '=', 'true'], ['trayekTypeId', '=', '8e072a19-599c-45f0-a337-08dbd378cce6']]
  })}`)
  if (!error) {
    trayekList.value = result as ITrayek[]
  }
}

const onTrayekChange = (e: any) => {
  if (e.value) {
    store.dispatch(`${module}/setFilterTrayek`, {
      label: e.value.Name,
      value: e.value.Id
    })
    selectedTrayek.value = null // reset dropdown selection after dispatching to chips
  }
}

const onClassChange = (e: any) => {
  if (e.value) {
    store.dispatch(`${module}/setFilterClass`, {
      label: e.value.Name,
      value: e.value.Id
    })
    selectedClass.value = null // reset dropdown selection after dispatching to chips
  }
}

const onTolChange = (e: any) => {
  if (e.value) {
    store.dispatch(`${module}/setFilterTol`, {
      label: e.value.label,
      value: e.value.value
    })
    selectedTol.value = null // reset dropdown selection after dispatching to chips
  }
}

const resetFilter = () => {
  store.dispatch(`${module}/flushPlottingFilters`)
}

onMounted(() => {
  getAllClass()
  getAllTrayek()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(Dropdown), {
        modelValue: selectedTrayek.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTrayek).value = $event)),
        options: trayekList.value,
        optionLabel: "Name",
        filter: "",
        placeholder: "Trayek",
        class: "w-full md:w-64 select-default",
        onChange: onTrayekChange
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_unref(Dropdown), {
        modelValue: selectedClass.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedClass).value = $event)),
        options: classList.value,
        optionLabel: "Name",
        filter: "",
        placeholder: "Kelas",
        class: "w-full md:w-48 select-default",
        onChange: onClassChange
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_unref(Dropdown), {
        modelValue: selectedTol.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedTol).value = $event)),
        options: optionTol.value,
        optionLabel: "label",
        placeholder: "Tol/Non Tol",
        class: "w-full md:w-48 select-default",
        onChange: onTolChange
      }, null, 8, ["modelValue", "options"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Button), {
          class: "text-sm px-4 py-2 flex items-center gap-2 rounded-lg hover:opacity-80 transition-opacity",
          onClick: resetFilter,
          style: {"border":"1px solid #BDE0FE","color":"#4791FC","background-color":"#ECF4FF"}
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})